
import React, { useState } from "react";
import axios from "../axios";
import { useSelector } from "react-redux";
const CreateTicket = ({ onclose, refetching }) => {
  const [typeData, setTypeData] = useState(null);
  const [titleData, setTitleData] = useState(null);
  const [descData, setDescData] = useState(null);
  let variables = JSON.parse(localStorage.getItem("breathForStudent"));
  const userId = useSelector((state) => state?.user?.currentUser?.id);

  const handleTicketCreation = async () => {
    try {
      let response = await axios.post(`/ticket/create`, {
        user_id: userId,
        ticket: titleData,
        description: descData,
        category: typeData,
        school_id: variables?.school?.id,
        standard_id: variables?.standard?.id,
        section_id: variables?.section?.id
      });
      // console.log(response.data.data);
      if (response) {
        onclose();
        refetching();
      }
    } catch (error) {
      throw error
    }
  }
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer1">
          <img src="/gif/user_connect_b4s.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Glad to be in your Service !!</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              Please Write your Issue,Query,Concern or Suggestion to us.
            </p>

            <p className="textColor3" id="last-paragraph">
              We will be Quick to Assist and Imporvise to Serve You Better.
            </p>
          </div>
          <select style={{ width: "70%", height: "30px", borderRadius: "5px", padding: "5px", border: "1px solid #F77F00" }} onChange={(e) => { setTypeData(e.target.value) }}>
            <option value=''>Select Ticket Type</option>
            <option value={"feature_issue"}>Feature Issue</option>
            <option value={"improvisation_feedback"}>Improvisation or Feedback</option>
          </select>
          <input
            style={{ width: "90%", height: "30px", borderRadius: "5px", marginTop: "10px", border: "1px solid #F77F00", padding: "5px" }}
            placeholder="Ticket Title (One Liner)"
            maxLength={150}
            onChange={(e) => { setTitleData(e.target.value) }}
          >
          </input>
          <textarea
            style={{
              width: "90%",
              height: "70px",
              borderRadius: "5px",
              marginTop: "10px",
              border: "1px solid #F77F00",
              padding: "5px",
              boxSizing: "border-box",
              resize: "none"
            }}
            placeholder="Please Write Issues, Queries, Concern or Suggestion here ..."
            maxLength={500}
            onChange={(e) => { setDescData(e.target.value) }}
          />
          <div className="buttonsContainer">
            <button
              style={{ width: "30%", marginRight: "20px" }}
              className="mt-2 btn btn-light creaeQueryBtn"
              onClick={() => { onclose() }}
            >
              Cancel
            </button>
            <button
              style={{ width: "30%", marginRight: "20px" }}
              className="mt-2 btn btn-light creaeQueryBtn"
              disabled={!titleData || !descData || !typeData}
              onClick={() => { handleTicketCreation() }}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTicket;
